// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookitupNotification } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';

const InvoicePublished: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { eventId, entityId } = notification;
  const navigate = useNavigate();

  return (
    <Text>
      Die{' '}
      <LinkText span onClick={() => navigate(`/events/${eventId}/documents/${entityId}/preview`)} weight="bolder">
        Rechnung
      </LinkText>{' '}
      wurde an die Buchhaltung übertragen.
    </Text>
  );
};

export default InvoicePublished;
